import React from 'react';
import ServiceTag from './ServiceTag';
import { Home, Building2, Droplet, Construction, Sparkles, Grid2X2 } from 'lucide-react';

// Estilos para iconos de servicio
const iconStyle = {
    width: "1.6rem",
    height: "1.6rem",
    strokeWidth: 1.8
  };

/* ---------------------------------------------------------------------------
   CÓMO AÑADIR MÁS VIDEOS A UN SERVICIO
   ---------------------------------------------------------------------------
   Cada servicio tiene un arreglo `videos`. Para añadir otro video de YouTube,
   copia el id del video (los 11 caracteres que van después de "v=" en la URL,
   por ejemplo https://www.youtube.com/watch?v=r16RdGM4HxI  ->  r16RdGM4HxI)
   y agrégalo como un objeto más dentro del arreglo:

     videos: [
       { id: "r16RdGM4HxI", title: "Window cleaning walkthrough" },
       { id: "OTRO_ID_AQUI", title: "Título del segundo video" },
       { id: "OTRO_ID_AQUI", title: "Título del tercer video" },
     ],

   El sitio se encarga del resto: la miniatura, el contador ("3 videos") y la
   lista dentro del reproductor aparecen solos.
--------------------------------------------------------------------------- */

const services = [
    {
      id: 1,
      title: "Window Cleaning",
      description: "Sunshine Clean all offers commercial and residential window cleaning services. Our crew has the knowledge and experience to confidently tackle any size window-cleaning need.",
      icon: <Grid2X2 style={iconStyle} />,
      videos: [
        { id: "EP9BW9dMtkw", title: "Window cleaning in action" },
        // Pega aquí más videos de YouTube de este servicio:
        // { id: "XXXXXXXXXXX", title: "Título del video" },
      ],
      additionalInfo: {
        fullDescription: "Our expert window cleaning service ensures crystal-clear results every time. We use high quality cleaning solutions and professional-grade equipment to leave your windows spotless. Whether it's a small residential project or a large commercial building, our trained professionals deliver exceptional results.",
        features: [
          "Safe and effective cleaning methods for all window types",
          "Advanced equipment for high-rise buildings",
          "Streak-free, crystal clear results guaranteed",
          "Interior and exterior window cleaning available",
          "Window cleaning and frame wiping included"
        ]
      }
    },
    {
      id: 2,
      title: "Steam Carpet and Furniture Cleaning",
      description: "Sunshine Clean All can help restore and maintain the original beauty of your carpet with professional carpet cleaning.",
      icon: <Sparkles style={iconStyle} />,
      videos: [
        { id: "ipziR8nRm-s", title: "Steam carpet cleaning in action" },
        // Pega aquí más videos de YouTube de este servicio:
        // { id: "XXXXXXXXXXX", title: "Título del video" },
      ],
      additionalInfo: {
        fullDescription: "Our steam carpet and furniture cleaning service removes deep dirt, stains, and allergens that regular cleaning can't reach. We use hot water extraction methods that are safe for all types of carpet fibers and upholstery materials.",
        features: [
          "Deep steam cleaning that removes 99% of allergens",
          "Specialized stain removal treatment",
          "Quick drying process with powerful extraction",
          "Pet odor neutralization technology",
          "Highly Rated & Esteemed Service"
        ]
      }
    },
    {
      id: 3,
      title: "Disinfecting Office Cleaning",
      description: "We know that businesses have to perform efficiently and properly each and every time, so your office cleaning service must be no different. We also recognize that what we do for you is a reflection on the image and reputation.",
      icon: <Building2 style={iconStyle} />,
      videos: [
        //{ id: "Ah6pib9P6s0", title: "Office disinfection in action" },
        // Pega aquí más videos de YouTube de este servicio:
        // { id: "XXXXXXXXXXX", title: "Título del video" },
      ],
      additionalInfo: {
        fullDescription: "Our comprehensive office disinfection services ensure your workplace remains clean, healthy, and productive. We are attentive down to the small details and we treat your business with personal care, because we want your staff and your customers to appreciate that you are looking after their health and environment.",
        features: [
          "Complete disinfection of high-touch surfaces",
          "Trusted Professionals with years of experience",
          "Special attention to break rooms",
          "Flexible service available for minimal disruption",
          "Custom cleaning schedules to fit your business needs"
        ]
      }
    },
    {
      id: 4,
      title: "Pressure Washing",
      description: "This service can quickly and effectively remove built-up dirt, sediment, and other debris. This not only helps the areas look beautiful, but it can also reduce wear and tear by getting rid of mold, algae, chalk, insects, weeds, and more.",
      icon: <Droplet style={iconStyle} />,
      videos: [
        { id: "Gd8uAdlN9lo", title: "Pressure washing in action" },
        // Pega aquí más videos de YouTube de este servicio:
        // { id: "XXXXXXXXXXX", title: "Título del video" },
      ],
      additionalInfo: {
        fullDescription: "Our professional pressure washing service restores the appearance of exterior surfaces by removing years of built-up dirt, grime, mold, and mildew. We adjust the pressure and technique according to the surface material to ensure safe and effective cleaning.",
        features: [
          "Safe cleaning for concrete, brick, stone, and wood surfaces",
          "Biodegradable cleaning solutions for environmental safety",
          "Removal of oil stains, mold, mildew, and algae",
          "Enhanced curb appeal for residential and commercial properties",
          "Special treatments for different surface types"
        ]
      }
    },
    {
      id: 5,
      title: "House Cleaning",
      description: "Take advantage of our most popular cleaning package. All your bathrooms, bedrooms and hallways get cleaned as well as your kitchen and living room, with Sunshine Clean All, it's a worry-free service.",
      icon: <Home style={iconStyle} />,
      videos: [
        { id: "EjOz2DtXWow", title: "House cleaning in action" },
        // Pega aquí más videos de YouTube de este servicio:
        // { id: "XXXXXXXXXXX", title: "Título del video" },
      ],
      additionalInfo: {
        fullDescription: "Our comprehensive house cleaning service takes care of every corner of your home. From dusting and vacuuming to deep cleaning bathrooms and kitchens, we ensure your living space is spotless, fresh, and healthy.",
        features: [
          "Kitchen deep cleaning including appliances",
          "Bathroom sanitizing and disinfection",
          "Dusting of all surfaces and fixtures",
          "Vacuuming and mopping of all floors",
          "Optional add-ons: window cleaning and organization"
        ]
      }
    },
    {
      id: 6,
      title: "New Construction Cleaning",
      description: "Sunshine Clean All can handle it all! Whether you are a home owner fighting with renovation dust, or a contractor in need of phased cleaning, our crew of professional cleaners are ready to make your work shine like the sun.",
      icon: <Construction style={iconStyle} />,
      videos: [
        { id: "G6p09Pk4ljU", title: "Post-construction cleaning in action" },
        // Pega aquí más videos de YouTube de este servicio:
        // { id: "XXXXXXXXXXX", title: "Título del video" },
      ],
      additionalInfo: {
        fullDescription: "Our new construction cleaning service prepares newly built or renovated properties for occupancy. We remove construction dust, debris, stickers, and protect surfaces while giving your property a thorough cleaning from top to bottom.",
        features: [
          "Removal of construction dust from all surfaces",
          "Cleaning of ducts and vents",
          "Interior window and glass cleaning",
          "Floor scrubbing and polishing",
          "Final touch-ups before occupancy"
        ]
      }
    }
];


const Services = () => {
    return (
      <section className="sec sec--porcelain" id='Services'>
        <div className="container">
          <div className="sec-head sec-head--center">
            <span className="eyebrow">What we clean</span>
            <h2 className="sec-title">Six services, one standard</h2>
            <p className="sec-lede">
              For over 20 years we have been bringing our brand of Sunshine
              Cleaning to the golden state. Every job leaves a home or office
              impeccably clean and organized — and the people in it comfortable.
            </p>
          </div>

          <div className="services-grid">
            {services.map(service => (
              <ServiceTag service={service} key={service.id} />
            ))}
          </div>
        </div>
      </section>
    );
}

export default Services;
